var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.24928 11.2501L17.9993 2.50014M9.35559 11.5235L11.5457 17.1552C11.7386 17.6513 11.8351 17.8994 11.9741 17.9718C12.0946 18.0346 12.2381 18.0347 12.3587 17.972C12.4978 17.8998 12.5946 17.6518 12.7881 17.1559L18.28 3.08281C18.4547 2.63516 18.5421 2.41133 18.4943 2.26831C18.4528 2.1441 18.3553 2.04663 18.2311 2.00514C18.0881 1.95736 17.8643 2.0447 17.4166 2.21939L3.34349 7.71134C2.84759 7.90486 2.59965 8.00163 2.52739 8.14071C2.46475 8.26129 2.46483 8.40483 2.52761 8.52533C2.60004 8.66433 2.8481 8.7608 3.34422 8.95373L8.97589 11.1438C9.0766 11.183 9.12695 11.2026 9.16935 11.2328C9.20693 11.2596 9.2398 11.2925 9.2666 11.3301C9.29685 11.3725 9.31643 11.4228 9.35559 11.5235Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.d351d2b33d72e758193f5124c88ee3f5.svg";
export { ForwardRef as ReactComponent };